import { render, staticRenderFns } from "./Montages.vue?vue&type=template&id=591f3eb4&scoped=true"
import script from "./Montages.vue?vue&type=script&setup=true&lang=ts"
export * from "./Montages.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Montages.vue?vue&type=style&index=0&id=591f3eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f3eb4",
  null
  
)

export default component.exports